import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="m15.524 16-3.44-3.445c-.419.36-.901.635-1.449.827a4.896 4.896 0 0 1-1.628.288c-1.334 0-2.46-.46-3.377-1.379-.918-.918-1.376-2.041-1.376-3.368 0-1.326.458-2.45 1.374-3.371.916-.921 2.038-1.382 3.368-1.382s2.455.46 3.376 1.38c.92.92 1.381 2.044 1.381 3.372 0 .577-.103 1.14-.31 1.688a4.623 4.623 0 0 1-.805 1.4l3.445 3.431-.559.559Zm-6.52-3.11c1.113 0 2.053-.382 2.82-1.146.766-.765 1.15-1.706 1.15-2.825 0-1.118-.384-2.06-1.15-2.823-.767-.764-1.708-1.146-2.825-1.146-1.116 0-2.056.382-2.82 1.147-.764.764-1.146 1.706-1.146 2.824 0 1.119.383 2.06 1.147 2.824.764.763 1.705 1.145 2.823 1.145Z"
    />
  </Svg>
)
export default SvgComponent
